
<div class="split-auth-container">


<!-- LEFT PANEL -->
<div class="split-left-panel">

    <div class="split-left-bg">
        <img src="assets/images/wedding.jpg"
             alt="Wedding Service"
             class="split-left-img">

        <div class="split-left-overlay"></div>
    </div>


    <div class="split-left-content">

        <span class="left-tagline">
            Grow With Love
        </span>

        <h1 class="left-title">
            Become a Wedding Partner
        </h1>


        <p class="left-desc">
            Showcase your wedding services to thousands
            of families searching for trusted partners.
        </p>


    </div>

</div>



<!-- RIGHT PANEL -->

<div class="split-right-panel">


<div class="onboarding-card">


<div class="auth-header">

<a routerLink="/" class="logo">
Weddingly Matrimony
</a>


<h2>
Become a Wedding Partner
</h2>


<p>
Register your business and reach customers
</p>


</div>




<form [formGroup]="merchantForm"
      (ngSubmit)="onSubmit()"
      class="auth-form">



<!-- STEP INDICATOR -->

<div class="step-indicator">

<span [class.active]="currentStep>=1">
1
</span>

<span [class.active]="currentStep>=2">
2
</span>

<span [class.active]="currentStep>=3">
3
</span>

</div>




<!-- STEP 1 BASIC DETAILS -->

<div *ngIf="currentStep===1">


<div class="form-group">

<label>
Business Name
</label>

<input class="warm-input"
formControlName="business_name"
placeholder="Royal Photography">


<div class="error-message"
*ngIf="merchantForm.get('business_name')?.touched &&
merchantForm.get('business_name')?.invalid">

Business name is required

</div>

</div>



<div class="row">


<div class="col-md-6 form-group">

<label>
Owner Name
</label>

<input class="warm-input"
formControlName="owner_name"
placeholder="Raj Kumar">


<div class="error-message"
*ngIf="merchantForm.get('owner_name')?.touched &&
merchantForm.get('owner_name')?.invalid">

Owner name is required

</div>

</div>



<div class="col-md-6 form-group">

<label>
Business Category
</label>


<select class="warm-input"
formControlName="category">


<option value="">
Select Category
</option>


<option *ngFor="let category of categories"
[value]="category._id">

{{category.name}}

</option>

</select>
<div class="error-message"
*ngIf="merchantForm.get('category')?.touched &&
merchantForm.get('category')?.invalid">

Please select business category

</div>


</div>


</div>




<div class="form-group">

<label>
Business Email
</label>


<input type="email"
class="warm-input"
formControlName="email"
placeholder="business@gmail.com">


<div class="error-message"
*ngIf="merchantForm.get('email')?.touched &&
merchantForm.get('email')?.errors?.['required']">

Email is required

</div>


<div class="error-message"
*ngIf="merchantForm.get('email')?.touched &&
merchantForm.get('email')?.errors?.['email']">

Enter valid email address

</div>


</div>





<div class="form-group">

<label>
Mobile Number
</label>


<div class="otp-row">

    <input 
        class="warm-input"
        maxlength="10"
        inputmode="numeric"
        formControlName="phone"
        placeholder="9876543210">

    <button 
        type="button"
        class="gold-button otp-button"
        (click)="sendOtp()">
        Send OTP
    </button>

</div>


<div class="error-message"
*ngIf="merchantForm.get('phone')?.touched &&
merchantForm.get('phone')?.errors?.['required']">

Mobile number is required

</div>


<div class="error-message"
*ngIf="merchantForm.get('phone')?.touched &&
merchantForm.get('phone')?.errors?.['invalidPhone']">

Mobile number must contain exactly 10 digits

</div>


</div>





<!-- OTP Verification Section -->

<div 
class="form-group"
*ngIf="otpSent">


<label>
Enter OTP
</label>


<div class="otp-row">

    <input
        class="warm-input"
        maxlength="6"
        inputmode="numeric"
        placeholder="Enter OTP"
        [(ngModel)]="otp"
        [ngModelOptions]="{standalone:true}">

    <button
        type="button"
        class="gold-button otp-button"
        (click)="verifyOtp()">
        Verify OTP
    </button>

</div>



<div 
class="success-message"
*ngIf="otpVerified">

Mobile number verified ✓

</div>


</div>


<button type="button"
class="gold-button"
(click)="nextStep()"
[disabled]="!otpVerified">

Continue

</button>


</div>






<!-- STEP 2 BUSINESS DETAILS -->

<div *ngIf="currentStep===2">


<div class="form-group">

<label>
Address Line 1
</label>


<input class="warm-input"
formControlName="address_line1"
placeholder="Door No, Street">


<div class="error-message"
*ngIf="merchantForm.get('address_line1')?.touched &&
merchantForm.get('address_line1')?.invalid">

Address is required

</div>


</div>



<div class="form-group">

<label>
Area / Locality
</label>


<input class="warm-input"
formControlName="area">


<div class="error-message"
*ngIf="merchantForm.get('area')?.touched &&
merchantForm.get('area')?.invalid">

Area is required

</div>


</div>




<div class="row">


<div class="col-md-6 form-group">

<label>
City
</label>


<select class="warm-input" formControlName="city">
  <option value="">Select City</option>
  <option *ngFor="let city of cities" [value]="city._id">
    {{city.city_nme}}
  </option>
</select>

<div class="error-message"
*ngIf="merchantForm.get('city')?.touched &&
merchantForm.get('city')?.invalid">

City is required

</div>


</div>



<div class="col-md-6 form-group">

<label>
District
</label>

<select class="warm-input" formControlName="district">
  <option value="">Select District</option>
  <option *ngFor="let district of districts" [value]="district._id">
    {{district.name_2}}
  </option>
</select>

<div class="error-message"
*ngIf="merchantForm.get('district')?.touched &&
merchantForm.get('district')?.invalid">

District is required

</div>


</div>


</div>




<div class="row">


<div class="col-md-6 form-group">

<label>
State
</label>

<select class="warm-input" formControlName="state">
  <option value="">Select State</option>
  <option *ngFor="let state of states" [value]="state._id">
    {{state.name_1}}
  </option>
</select>

<div class="error-message"
*ngIf="merchantForm.get('state')?.touched &&
merchantForm.get('state')?.invalid">

State is required

</div>


</div>



<div class="col-md-6 form-group">

<label>
Pincode
</label>


<input 
class="warm-input"
maxlength="6"
inputmode="numeric"
formControlName="pincode">


<div class="error-message"
*ngIf="merchantForm.get('pincode')?.touched &&
merchantForm.get('pincode')?.errors?.['required']">

Pincode is required

</div>


<div class="error-message"
*ngIf="merchantForm.get('pincode')?.touched &&
merchantForm.get('pincode')?.errors?.['invalidPincode']">

Pincode must contain 6 digits

</div>


</div>


</div>





<div class="form-group">

<label>
Years of Experience
</label>


<input class="warm-input"
formControlName="years_of_experience">


<div class="error-message"
*ngIf="merchantForm.get('years_of_experience')?.touched &&
merchantForm.get('years_of_experience')?.invalid">

Experience is required

</div>


</div>





<div class="form-group">

<label>
Business Description
</label>


<textarea 
class="warm-input"
formControlName="business_description">
</textarea>


<div class="error-message"
*ngIf="merchantForm.get('business_description')?.touched &&
merchantForm.get('business_description')?.invalid">

Business description is required

</div>


</div>





<button type="button"
class="gold-button secondary"
(click)="previousStep()">

Back

</button>



<button type="button"
class="gold-button"
(click)="nextStep()">

Continue

</button>



</div>






<!-- STEP 3 VERIFICATION -->

<div *ngIf="currentStep===3">





<div class="form-group">
<label>
Upload Aadhaar Card
</label>

<input type="file"
(change)="onFileChange($event,'aadhaar_card')">
</div>

<div class="form-group">

<label>
Profile Picture
</label>


<input type="file"
(change)="onFileChange($event,'profile_pic')">


</div>






<div class="form-group">

<label>
Password
</label>


<input 
type="password"
class="warm-input"
formControlName="password">


<div class="error-message"
*ngIf="merchantForm.get('password')?.touched &&
merchantForm.get('password')?.errors?.['required']">

Password is required

</div>


<div class="error-message"
*ngIf="merchantForm.get('password')?.touched &&
merchantForm.get('password')?.errors?.['minlength']">

Password minimum length is 8 characters

</div>


</div>




<div class="form-group">

<label>
Confirm Password
</label>


<input 
type="password"
class="warm-input"
formControlName="confirm_password">


<div class="error-message"
*ngIf="merchantForm.get('confirm_password')?.touched &&
merchantForm.get('confirm_password')?.invalid">

Confirm password is required

</div>


<div class="error-message"
*ngIf="merchantForm.touched &&
merchantForm.errors?.['passwordMismatch']">

Password and confirm password must match

</div>


</div>






<button type="button"
class="gold-button secondary"
(click)="previousStep()">

Back

</button>




<button 
type="submit"
class="gold-button"
[disabled]="merchantForm.invalid">

Register as Merchant

</button>



</div>





</form>




<div class="auth-footer">

<p>
Already registered?

<a routerLink="/merchant/login">
Merchant Login
</a>

</p>


</div>



</div>


</div>
</div>
